import React from 'react'

import HeadNext from 'next/head'

import { useAppContext } from 'context/AppContext'
import routeService from 'services/routes'

/** @type {import('./types').default} */
const Seo = ({
  title,
  description,
  route,
  pagination = {},
  image = 'https://www.getapp.com/i/og_logo.jpg',
  children,
  url: reqUrl,
}) => {
  const { host } = useAppContext()
  let calculatedTitle = pagination.page && pagination.page > 1 ? `${title} | Page ${pagination.page}` : title
  let calculatedDescription =
    pagination.page && pagination.page > 1 ? `Page ${pagination.page} | ${description}` : description
  calculatedTitle = (calculatedTitle || '').replace(/(\n|\r)+/g, ' ')
  calculatedDescription = (calculatedDescription || '').replace(/(\n|\r)+/g, ' ')

  const url = routeService.generatePath(
    route.name,
    { ...route.params, page: pagination.page && pagination.page > 1 ? pagination.page : undefined },
    { domain: host }
  )

  const robots = (reqUrl || '').includes('?') ? 'noindex, nofollow' : ''
  const isIndexing = !robots.includes('noindex')

  return (
    <HeadNext>
      <title>{calculatedTitle}</title>
      <meta content="#454a4f" key="theme-color" name="theme-color" />
      <meta content="#00aba9" key="msapplication-TileColor" name="msapplication-TileColor" />
      <meta charSet="utf-8" />
      <meta key="title" name="title" content={calculatedTitle} />
      <meta key="description" name="description" content={calculatedDescription} />
      <meta property="og:type" content="website" />
      <meta key="og:title" property="og:title" content={calculatedTitle} />
      <meta key="og:description" property="og:description" content={calculatedDescription} />
      <meta key="og:url" property="og:url" content={url} />
      <meta key="og:image" property="og:image" content={image} />
      <meta key="twitter:description" name="twitter:description" content={calculatedDescription} />
      <meta key="twitter:title" name="twitter:title" content={calculatedTitle} />
      <meta key="twitter:url" name="twitter:url" content={url} />
      <meta key="twitter:image" name="twitter:image" content={image} />
      <meta key="og:locale" property="og:locale" content="en_US" />
      <meta key="og:site_name" property="og:site_name" content="GetApp" />
      <meta key="twitter:card" name="twitter:card" content="summary_large_image" />
      <meta key="twitter:site" name="twitter:site" content="@GetApp" />
      <meta key="twitter:creator" name="twitter:creator" content="@GetApp" />
      <meta itemProp="image" content={image} />
      <link href="/apple-touch-icon.png" rel="apple-touch-icon" sizes="180x180" />
      <link href="/favicon.ico" rel="icon" sizes="any" type="image/x-icon" />
      <link href="/safari-pinned-tab.svg" rel="mask-icon" color="#5bbad5" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
      <meta key="HandheldFriendly" name="HandheldFriendly" content="True" />
      <meta key="MobileOptimized" name="MobileOptimized" content="320" />
      <meta
        key="viewport"
        name="viewport"
        content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=5  shrink-to-fit=no"
      />
      <meta key="format-detection" name="format-detection" content="telephone=no, email=no" />
      <meta key="apple-mobile-web-app-capable" name="apple-mobile-web-app-capable" content="no" />
      <meta key="referrer" name="referrer" content="unsafe-url" />
      <meta httpEquiv="Accept-CH" content="DPR, Viewport-Width, Width" />
      {robots && <meta name="robots" content={robots} />}
      {isIndexing && <link href={url} rel="canonical" />}

      {pagination.page && pagination.page > 1 && (
        <link
          rel="prev"
          href={routeService.generatePath(
            route.name,
            { ...route.params, page: pagination.page === 2 ? undefined : pagination.page - 1 },
            { domain: host }
          )}
        />
      )}
      {pagination.page && pagination.total && pagination.page < pagination.total && (
        <link
          rel="next"
          href={routeService.generatePath(route.name, { ...route.params, page: pagination.page + 1 }, { domain: host })}
        />
      )}
      {children}
    </HeadNext>
  )
}

export default Seo
